import type { BlogFeedItem } from "@/features/home/api/blogFeed";
import { WEBSITE_URL } from "@/features/config";
import { PINNED_BLOG_POST } from "./pinnedBlogPost";

export const FALLBACK_BLOG_POSTS: BlogFeedItem[] = [
  {
    title: "Adding biological databases to Paperclip",
    url: `${WEBSITE_URL}/blog/adding-biology-databases`,
    pubDate: new Date("2026-07-09"),
  },
  {
    title: "Announcing Paperclip chat",
    url: `${WEBSITE_URL}/blog/announcing-paperclip-chat`,
    pubDate: new Date("2026-06-25"),
  },
  PINNED_BLOG_POST,
];
